import PropTypes from "prop-types";
import React from "react";

import FollowUpProvider from "../context/FollowUpContext";

import FollowUpSection from "./ui/FollowUpSection";

const FollowUpViews = ({ divId, actionType, caseInfo, limit, title, icon, actionTypeList }) => {
  return (
    <div id="Follow-Ups-Views" data-testid="Follow-Ups-Views">
      <FollowUpProvider>
        <FollowUpSection
          divId={divId}
          title={title}
          icon={icon}
          limit={limit}
          actionType={actionType}
          caseInfo={caseInfo}
          actionTypeList={actionTypeList}
        />
      </FollowUpProvider>
    </div>
  );
};

FollowUpViews.propTypes = {
  divId: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.object,
  limit: PropTypes.number,
  actionType: PropTypes.number,
  caseInfo: PropTypes.object,
};

export default FollowUpViews;
